export const SELECTED_TVCHANNEL = "SELECTED_TVCHANNEL" ;
export const SELECTED_GENER = "SELECTED_GENER" ;
export const SELECTED_FILTER = "SELECTED_FILTER" ;
export const SELECTED_TVCHANNELFILTER = "SELECTED_TVCHANNELFILTER" ;
export const SELECTED_COUNTRY = "SELECTED_COUNTRY" ;
export const SELECTED_COUNTRYName = "SELECTED_COUNTRYName" ;
export const SELECTED_COUNTRYFlag = "SELECTED_COUNTRYFlag" ;
export const SELECTED_TITLE = 'SELECTED_TITLE';
export const SELECTED_DESCRIPTION = 'SELECTED_DESCRIPTION';
export const SELECTED_IMAGE = 'SELECTED_IMAGE';